module.exports = __webpack_public_path__ + "img/5-3.bf5c6356.jpg";